import { createSlice } from '@reduxjs/toolkit';

export const shiftDemandsSlice = createSlice({
    name: 'shift_demands',
    initialState: {
        shift_demands_list: null as any,
        shift_demands_list_select: null as any,
        shift_demand: null as any,
        meta: null as any,
    },
    reducers: {
        setShiftDemandsListRedux: (state, action) => {
            state.shift_demands_list = action.payload;
        },
        setShiftDemandsListSelectRedux: (state, action) => {
            state.shift_demands_list_select = action.payload;
        },
        setShiftDemandRedux: (state, action) => {
            state.shift_demand = action.payload;
        },
        setMetaShiftDemandsRedux: (state, action) => {
            state.meta = action.payload;
        }
    }
});

export const {
    setShiftDemandsListRedux,
    setShiftDemandsListSelectRedux,
    setShiftDemandRedux,
    setMetaShiftDemandsRedux
} = shiftDemandsSlice.actions;
